export const authModule = {
  name: 'Auth',
};
